<script>
import ClubEmployeeRepository from '../../js/repository/ClubEmployeeRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        employeeId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
            default: () => {},
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ClubEmployeeRepository.getKnowledgeData,
                params: [this.employeeId],
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
